module.exports = __webpack_public_path__ + "static/media/Bicocca - white_dark grey.eafa4f15.jpg";